module.exports = __webpack_public_path__ + "media/promo/advent/images/cells/cell-28-c43c18e2b6eabf9466c716041ab0bcdd.png";